export default {
  B2B_RAF: false,
};
